import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SvgIcon from "../../Components/Common/Component/SvgIcon";
import CustomizerContext from "../../_helper/Customizer";
import { MENUITEMS } from "./Menu";
import { getCurrentSubscription } from "../../api-handle/merchantSubscriptionApi";
import { toast } from "react-toastify";

const SidebarMenuItems = ({
  setMainMenu,
  sidebartoogle,
  setNavActive,
  activeClass,
  props
}) => {
  const { layout, toggleSidebar } = useContext(CustomizerContext);
  const layout1 = localStorage.getItem("sidebar_layout") || layout;
  const CurrentPath = window.location.pathname;
  const layoutId = "";
  const { t } = useTranslation();

  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [menuItems, setMenuItems] = useState(MENUITEMS); // local menu state

  const GetCurrentSubscription = async () => {
    try {
      const res = await getCurrentSubscription();
      setCurrentSubscription(res.subscription || null); // Handle null response
    } catch (error) {
      console.error("Error fetching subscription:", error.message);
      setCurrentSubscription(null);
      // Don't show error toast for pending merchants or when subscription is simply not found
      // These are expected scenarios, not actual errors
      const errorMessage = error?.message || error?.error?.message || '';
      const isExpectedError = 
        errorMessage.includes('Merchant not approved') ||
        errorMessage.includes('not approved') ||
        error?.statusCode === 401;
      
      if (!isExpectedError) {
        toast.error("Failed to fetch subscription");
      }
    }
  };

  useEffect(() => {
    GetCurrentSubscription();
  }, []);

  useEffect(() => {
    if (!currentSubscription) {
      // Only show My-Subscriptions tab if no subscription
      const mySubscriptionTab = MENUITEMS[0].Items.find(
        (item) => item.title === "My-Subscriptions"
      );

      setMenuItems([
        {
          ...MENUITEMS[0],
          Items: mySubscriptionTab ? [mySubscriptionTab] : [],
        },
      ]);
    } else {
      setMenuItems(MENUITEMS); // restore full menu if subscription exists
    }
  }, [currentSubscription]);

  const toggletNavActive = (item) => {
    const pageHeader = document.querySelector(".page-header");
    const sidebarWrapper = document.querySelector(".sidebar-wrapper");
    const megaMenu = document.querySelector(".mega-menu-container");

    if (window.innerWidth <= 991) {
      const bgOverlay = document.querySelector(".bg-overlay1");
      megaMenu?.classList.remove("d-block");

      if (item.type === "sub") {
        pageHeader?.classList.remove("close_icon");
        sidebarWrapper?.classList.remove("close_icon");
        toggleSidebar(false);
      } else {
        pageHeader?.classList.add("close_icon");
        sidebarWrapper?.classList.add("close_icon");
        bgOverlay?.classList.remove("active");
        toggleSidebar(true);
      }
    }

    if (!item.active) {
      menuItems.forEach((menu) => {
        menu.Items.forEach((menuItem) => {
          menuItem.active = menuItem === item;

          if (menuItem.children) {
            menuItem.children.forEach((child) => {
              child.active = child === item;

              if (child.children) {
                child.children.forEach((subChild) => {
                  subChild.active = subChild === item;
                });
              }
            });
          }
        });
      });
    }

    item.active = !item.active;
    setMainMenu({ mainmenu: menuItems });
  };

  /** Keep parent submenu expanded when current path matches any child path (or parent title). */
  const isParentExpanded = (menuItem) => {
    if (!menuItem) return false;
    if (menuItem.active) return true;
    if (CurrentPath.includes(menuItem.title?.toLowerCase?.() ?? "")) return true;
    if (menuItem.children?.length) {
      const normalizedCurrent = (CurrentPath || "").replace(/\/$/, "") || "/";
      return menuItem.children.some((child) => {
        const path = (child.path || "").replace(/\/$/, "");
        if (!path) return false;
        return normalizedCurrent === path || normalizedCurrent.startsWith(path + "/");
      });
    }
    return false;
  };

  /** True when current route matches this child link (for active dot on nested items e.g. Gym Plans, Subscribers). */
  const isChildLinkActive = (child) => {
    if (!child?.path) return false;
    const normalizedCurrent = (CurrentPath || "").replace(/\/$/, "") || "/";
    const path = (child.path || "").replace(/\/$/, "");
    return normalizedCurrent === path || normalizedCurrent.startsWith(path + "/");
  };

  return (
    <>
      {menuItems.map((Item, i) => (
        <Fragment key={i}>
          <li className="sidebar-main-title">
            <div>
              <h6 className="lan-1">{t(Item.menutitle)}</h6>
            </div>
          </li>
          {Item.Items.map((menuItem, i) => (
            <li className="sidebar-list" key={i}>
              {menuItem.type === "sub" ? (
                <a
                  href="javascript"
                  className={`sidebar-link sidebar-title ${isParentExpanded(menuItem) ? "active" : ""}`}
                  onClick={(event) => {
                    if (props.disable) {
                      event.preventDefault();
                      return;
                    } else {
                      event.preventDefault();
                      setNavActive(menuItem);
                      activeClass(menuItem.active);
                    }
                  }}
                >
                  {menuItem.iconId === false && menuItem.icon}
                  <span>{t(menuItem.title.replace(/-/g, ' '))}</span>
                  {menuItem.badge ? (
                    <label className={menuItem.badge}>
                      {menuItem.badgetxt}
                    </label>
                  ) : (
                    ""
                  )}
                  <div className="according-menu">
                    {isParentExpanded(menuItem) ? (
                      <i className="fa fa-angle-down"></i>
                    ) : (
                      <i className="fa fa-angle-right"></i>
                    )}
                  </div>
                </a>
              ) : (
                ""
              )}

              {menuItem.type === "link" ? (
                <Link
                  to={props.disable ? "#" : menuItem.path + "/" + layoutId}
                  className={`sidebar-link sidebar-title link-nav ${CurrentPath.includes(menuItem.title.toLowerCase()) ? "active" : ""} ${props.disable ? "disabled-link" : ""}`}
                  onClick={(e) => {
                    if (props.disable) {
                      e.preventDefault();
                      return;
                    }
                    toggletNavActive(menuItem);
                  }}
                >
                  {menuItem.iconId === false && menuItem.icon}
                  <span>{t(menuItem.title.replace(/-/g, ' '))}</span>
                  {menuItem.badge ? (
                    <label className={menuItem.badge}>{menuItem.badgetxt}</label>
                  ) : (
                    ""
                  )}
                </Link>
              ) : (
                ""
              )}

              {menuItem.children ? (
                <ul
                  className="sidebar-submenu"
                  style={
                    layout1 !== "compact-sidebar compact-small"
                      ? isParentExpanded(menuItem)
                        ? sidebartoogle
                          ? { opacity: 1, transition: "opacity 500ms ease-in" }
                          : { display: "block" }
                        : { display: "none" }
                      : { display: "none" }
                  }
                >
                  {menuItem.children.map((childrenItem, index) => {
                    return (
                      <li key={index}>
                        {childrenItem.type === "sub" ? (
                          <a
                            href="javascript"
                            className={`${CurrentPath.includes(
                              childrenItem?.title?.toLowerCase()
                            )
                              ? "active"
                              : ""
                              }`}
                            // className={`${childrenItem.active ? 'active' : ''}`}
                            onClick={(event) => {
                              event.preventDefault();
                              toggletNavActive(childrenItem);
                            }}
                          >
                            {t(childrenItem.title)}
                            <span className="sub-arrow">
                              <i className="fa fa-chevron-right"></i>
                            </span>
                            <div className="according-menu">
                              {childrenItem.active ? (
                                <i className="fa fa-angle-down"></i>
                              ) : (
                                <i className="fa fa-angle-right"></i>
                              )}
                            </div>
                          </a>
                        ) : (
                          ""
                        )}

                        {childrenItem.type === "link" ? (
                          <Link
                            to={childrenItem.path + "/" + layoutId}
                            className={isChildLinkActive(childrenItem) ? "active" : ""}
                            onClick={() => toggletNavActive(childrenItem)}
                          >
                            {t(childrenItem.title)}
                          </Link>
                        ) : (
                          ""
                        )}

                        {childrenItem.children ? (
                          <ul
                            className="nav-sub-childmenu submenu-content"
                            style={
                              CurrentPath.includes(
                                childrenItem?.title?.toLowerCase()
                              ) || childrenItem.active
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            {childrenItem.children.map(
                              (childrenSubItem, key) => (
                                <li key={key}>
                                  {childrenSubItem.type === "link" ? (
                                    <Link
                                      to={childrenSubItem.path + "/" + layoutId}
                                      className={`${CurrentPath.includes(
                                        childrenSubItem?.title?.toLowerCase()
                                      )
                                        ? "active"
                                        : ""
                                        }`}
                                      // className={`${childrenSubItem.active ? 'active' : ''}`}
                                      onClick={() =>
                                        toggletNavActive(childrenSubItem)
                                      }
                                    >
                                      {t(childrenSubItem.title)}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              )
                            )}
                          </ul>
                        ) : (
                          ""
                        )}
                      </li>
                    );
                  })}
                </ul>
              ) : (
                ""
              )}
            </li>
          ))}
        </Fragment>
      ))}
    </>
  );
};

export default SidebarMenuItems;
